import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../components/config";
import "../style/Observaciones.css";

const Observaciones = () => {
  const token = localStorage.getItem("token");

  const axiosConfig = {
    headers: { Authorization: `Bearer ${token}` }
  };

  // ===============================
  // STATE
  // ===============================
  const [asignaciones, setAsignaciones] = useState([]);
  const [estudiantes, setEstudiantes] = useState([]);
  const [periodos, setPeriodos] = useState([]);
  const [periodoActivo, setPeriodoActivo] = useState(null);
  const [lista, setLista] = useState([]);

  const [filtro, setFiltro] = useState({
    materia_id: "",
    estudiante_id: "",
    periodo_id: ""
  });

  const [form, setForm] = useState({
    tipo: "general",
    observacion: "",
    accion_requerida: ""
  });

  // ===============================
  // CARGA INICIAL
  // ===============================
  useEffect(() => {
    cargarInicial();
  }, []);

  const cargarInicial = async () => {
    try {
      const [asigRes, perRes] = await Promise.all([
        axios.get(`${API}/observaciones/asignaciones`, axiosConfig),
        axios.get(`${API}/observaciones/periodos`, axiosConfig)
      ]);

      setAsignaciones(Array.isArray(asigRes.data) ? asigRes.data : []);
      setPeriodos(Array.isArray(perRes.data.todos) ? perRes.data.todos : []);
      setPeriodoActivo(perRes.data.activo || null);

    } catch (err) {
      console.error("❌ Error carga inicial:", err);
    }
  };

  // ===============================
  // ESTUDIANTES POR CURSO
  // ===============================
  const cargarEstudiantes = async (grado, grupo) => {
    try {
      const res = await axios.get(`${API}/observaciones/estudiantes`, {
        params: { grado, grupo },
        ...axiosConfig
      });

      setEstudiantes(Array.isArray(res.data) ? res.data : []);

    } catch (err) {
      console.error("❌ Error estudiantes:", err);
    }
  };

  // ===============================
  // CONSULTAR HISTORIAL
  // ===============================
  const consultar = async () => {
    if (!filtro.estudiante_id || !filtro.materia_id || !filtro.periodo_id) {
      alert("⚠️ Complete todos los filtros");
      return;
    }

    try {
      const res = await axios.get(`${API}/observaciones/materia`, {
        params: filtro,
        ...axiosConfig
      });

      setLista(Array.isArray(res.data) ? res.data : []);

    } catch (err) {
      console.error("❌ Error consultar:", err);
    }
  };

  // ===============================
  // CREAR OBSERVACION
  // ===============================
  const crear = async () => {
    if (!filtro.estudiante_id || !filtro.materia_id) {
      alert("⚠️ Seleccione estudiante y asignación");
      return;
    }

    if (!form.observacion.trim()) {
      alert("⚠️ La observación está vacía");
      return;
    }

    try {
      await axios.post(`${API}/observaciones`, {
        estudiante_id: filtro.estudiante_id,
        materia_id: filtro.materia_id,
        tipo: form.tipo,
        observacion: form.observacion,
        accion_requerida: form.accion_requerida
      }, axiosConfig);

      alert("✅ Observación guardada");

      setForm({
        tipo: "general",
        observacion: "",
        accion_requerida: ""
      });

      if (filtro.periodo_id) {
        consultar();
      }

    } catch (err) {
      console.error("❌ Error crear:", err);
      alert("Error guardando observación");
    }
  };

  // ===============================
  // PUBLICAR EN BOLETIN
  // ===============================
  const enviarABoletin = async (id) => {
    try {
      await axios.patch(`${API}/observaciones/publicar-boletin/${id}`, {}, axiosConfig);

      alert("✅ Observación enviada al boletín");

      consultar();

    } catch (err) {
      console.error("❌ Error publicar boletín:", err);
      alert(err.response?.data?.message || "No se pudo publicar");
    }
  };

  // ===============================
  // COLOR BADGE
  // ===============================
  const colorTipo = (tipo) => {
    const colors = {
      disciplinaria: "#e74c3c",
      academica: "#3498db",
      general: "#7f8c8d"
    };
    return colors[tipo] || colors.general;
  };

  // ===============================
  // UI
  // ===============================
  return (
    <div className="obs-container">

      <header className="obs-header">
        <h2>📌 Módulo de Observaciones</h2>
      </header>

      {/* ===============================
          SELECTORES
      =============================== */}
      <section className="obs-selectors-grid">

        <div className="obs-field-group">
          <label>Asignación Docente</label>
          <select
            className="obs-select"
            onChange={(e) => {
              const asig = asignaciones.find(a => a.id == e.target.value);
              if (!asig) return;

              setFiltro(prev => ({
                ...prev,
                materia_id: asig.materia_id,
                estudiante_id: "",
                periodo_id: ""
              }));

              setEstudiantes([]);
              setLista([]);

              cargarEstudiantes(asig.grado, asig.grupo);
            }}
          >
            <option value="">Seleccione Asignación...</option>
            {asignaciones.map(a => (
              <option key={a.id} value={a.id}>
                {a.materia} - {a.grado}°{a.grupo}
              </option>
            ))}
          </select>
        </div>

        <div className="obs-field-group">
          <label>Estudiante</label>
          <select
            className="obs-select"
            value={filtro.estudiante_id}
            onChange={(e) => setFiltro(prev => ({
              ...prev,
              estudiante_id: e.target.value
            }))}
          >
            <option value="">Seleccione Estudiante...</option>
            {estudiantes.map(e => (
              <option key={e.id} value={e.id}>
                {e.nombres_estudiante} {e.apellidos_estudiante}
              </option>
            ))}
          </select>
        </div>

        <div className="obs-field-group">
          <label>Periodo a Consultar</label>
          <select
            className="obs-select"
            value={filtro.periodo_id}
            onChange={(e) => setFiltro(prev => ({
              ...prev,
              periodo_id: e.target.value
            }))}
          >
            <option value="">Seleccione Periodo...</option>
            {periodos.map(p => (
              <option key={p.id} value={p.id}>
                Periodo {p.numero} {Number(p.activo) === 1 ? "(Activo)" : ""}
              </option>
            ))}
          </select>
        </div>

      </section>

      <button onClick={consultar} className="obs-btn obs-btn-query">
        🔍 Consultar Historial Estudiantil
      </button>

      {/* ===============================
          FORMULARIO
      =============================== */}
      <div className="obs-card">

        <div className="obs-period-info">
          📅 Periodo Activo: {periodoActivo ? periodoActivo.nombre : "Sin periodo activo"}
        </div>

        <div className="obs-field-group" style={{ marginBottom: "15px" }}>
          <label>Tipo de Observación</label>
          <select
            className="obs-select"
            value={form.tipo}
            onChange={(e) => setForm({ ...form, tipo: e.target.value })}
          >
            <option value="general">Informativa / General</option>
            <option value="academica">Académica</option>
            <option value="disciplinaria">Disciplinaria</option>
          </select>
        </div>

        <div className="obs-field-group" style={{ marginBottom: "15px" }}>
          <label>Detalle de la Observación</label>
          <textarea
            className="obs-textarea"
            placeholder="Describa el desempeño del estudiante..."
            value={form.observacion}
            onChange={(e) => setForm({ ...form, observacion: e.target.value })}
          />
        </div>

        <div className="obs-field-group" style={{ marginBottom: "20px" }}>
          <label>Acción o Compromiso Sugerido</label>
          <input
            className="obs-input"
            placeholder="Ej: Citación a padres, plan de mejora..."
            value={form.accion_requerida}
            onChange={(e) => setForm({ ...form, accion_requerida: e.target.value })}
          />
        </div>

        <button onClick={crear} className="obs-btn obs-btn-save">
          💾 Guardar Registro
        </button>
      </div>

      {/* ===============================
          HISTORIAL
      =============================== */}
      <div className="obs-history-section">
        <h3 style={{ color: "#2c3e50", marginBottom: "20px" }}>
          📚 Historial de Seguimiento
        </h3>

        {lista.length === 0 && (
          <p style={{ textAlign: "center", color: "#7f8c8d" }}>
            No hay registros para esta consulta.
          </p>
        )}

        {lista.map(o => (
          <div
            key={o.id}
            className="obs-history-item"
            style={{ borderLeft: `6px solid ${colorTipo(o.tipo)}` }}
          >
            <span className="obs-badge" style={{ background: colorTipo(o.tipo) }}>
              {o.tipo}
            </span>

            <p className="obs-text">{o.observacion}</p>

            {o.accion_requerida && (
              <div className="obs-action-box">
                <strong>Acción:</strong> {o.accion_requerida}
              </div>
            )}

            <div className="obs-footer">
              <span>📖 {o.materia}</span>
              <span>
                📅 {new Date(o.fecha).toLocaleDateString()} -{" "}
                {new Date(o.fecha).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit"
                })}
              </span>
            </div>

            {/* 🔥 BOTON BOLETIN */}
            <div style={{ marginTop: "12px", textAlign: "right" }}>
              {Number(o.enviar_boletin) === 1 ? (
                <small style={{ color: "green", fontWeight: "bold" }}>
                  ✔ Visible en boletín
                </small>
              ) : (
                <button
                  onClick={() => enviarABoletin(o.id)}
                  style={{
                    fontSize: "12px",
                    padding: "6px 12px",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    background: "#27ae60",
                    color: "#fff"
                  }}
                >
                  📤 Enviar al boletín
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Observaciones;
